import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { routes, useHasPermission } from "../utils/route.utils";
import PageLayout from "../layouts/PageLayout";
import { arrayMap } from "../utils/array.utils";

export default function Pages() {
  const navigate = useNavigate();
  const { displayNone } = useHasPermission();

  const data = routes;

  const dataLength = data?.length;

  const handleRoute = (route) => {
    navigate(route);
  };

  const breadCrumbs = [
    {
      name: "Pages",
      link: "/pages"
    },
    {
      name: "Current"
    }
  ];

  return (
    <PageLayout title={"Pages"} subTitle={`Total: ${dataLength}`} breadCrumbs={breadCrumbs}>
      <div className="row g-3">
        {arrayMap(data, (item, index) => (
          <CardContainer
            key={index + 1}
            className={`col-12 col-md-4 col-xl-3 ${displayNone(item.permissions)}`}
            onClick={() => handleRoute(item?.route)}>
            <div className="card ">
              <div className="card-body">{item?.name ?? ""}</div>
            </div>
          </CardContainer>
        )) || <div className="text-center">No pages</div>}
      </div>
    </PageLayout>
  );
}

const CardContainer = styled.div`
  cursor: pointer;

  .card {
    transition: background-color 0.3s ease;
    font-size: 0.8rem;
    font-weight: 600;
    border: 0;
    background-color: rgb(var(--primary) / 0.1);
  }

  .card:hover {
    border: 0;
    background-color: rgb(var(--primary) / 1);
    color: white;
  }
`;
